import { AuthModule } from '@/auth/auth.module';
import { UserRequestsModule } from '@/app/private/user-requests/user-requests.module';
import { AppModule } from './modules/app.module';
import { CourseTemplatesModule } from '@/course-templates/course-templates.module';
import { CoursesModule } from '@/courses/courses.module';
import { BuilderModule } from '@/courses/builder.module';
import { MeetingsModule } from '@/meetings/meetings.module';

export const CoreModule = {
  install: (Vue) => {
    Vue.prototype.$Auth = new AuthModule();
    Vue.prototype.$UserRequests = new UserRequestsModule();
    Vue.prototype.$App = new AppModule();
    Vue.prototype.$CourseTemplates = new CourseTemplatesModule();
    Vue.prototype.$Courses = new CoursesModule();
    Vue.prototype.$Builder = new BuilderModule();
    Vue.prototype.$Meetings = new MeetingsModule();
  }
}
